export const BRAND = "Gondoskodás & Biztonság Időskorban";
export const PHONE_DISPLAY = "06 20 542 1428";
export const TEL_HREF = "tel:+36205421428";
export const WHATSAPP_HREF = "https://wa.me/36205421428";
export const VIBER_HREF = "viber://chat?number=%2B36205421428";
export const SERVICE_AREA = "Egész Magyarország";
export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const INTERESTS = [
  "Eltartási szerződés érdekel",
  "Életjáradék érdekel",
  "Még nem döntöttem",
];

export function formatApiError(detail) {
  if (detail == null) return "Valami hiba történt. Kérjük, próbálja újra.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return "Kérjük, ellenőrizze a megadott adatokat.";
  return String(detail);
}
